
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import './Save.css';

function SaveList(props) {
  const historylist = props.historyList;
  const items = historylist.map((item,index) =>
      <div className="item" key={index}>
          <label className="date" id={index} onClick={props.onClick}>
              <span className="num">{index+1}</span>
              Revealed &nbsp; {item.boughtYantra.day}/{item.boughtYantra.month}/{item.boughtYantra.year}
          </label>
      </div>
    );

  return (
      <div className="lbl-group tbl">
          {items}
      </div>
  );
}

class SaveForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect:false,
      pathname: '/details',
      key: 0,
      historyList: [],
    }
  }

  setRedirect = (event) => {
    // currentTarget (the element the listener is attached to, i.e. the
    // <label id={index}>) rather than target (whichever descendant node was
    // actually clicked, which had no id of its own after the markup cleanup).
    this.setState({key:event.currentTarget.id, redirect:true});
  }

  googleLogout = () => {
    if(localStorage.getItem('google_access_token')) {
      window.google.accounts.id.disableAutoSelect();
      localStorage.removeItem('google_access_token');
      /*window.gapi.auth.authorize(
          {
            'client_id': '189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com',
            'scope': 'profile email',
            'immediate': false,
            cookie_policy: 'single_host_origin',
            response_type: localStorage.getItem('google_access_token')
          },
          function (authResult) {
            window.gapi.auth.signOut();
            // localStorage.removeItem('google_access_token');
          }
      );*/
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      if(this.state.pathname === '/details') {
        const key = this.state.key;
        const history = this.state.historyList[key].boughtYantra;
        const data = this.state.historyList[key];
        const day = history.day;
        const month = history.month;
        const year = history.year;
        return <Redirect to={{
          pathname: this.state.pathname,
          state: {
            data: data,
            day: day,
            month: month,
            year: year,
          },
        }}/>
      } else {
        return <Redirect to={{
          pathname: this.state.pathname
        }}/>
      }
    }
  }

  componentDidMount = () => {
    var jwt_token = localStorage.getItem('y_jwt_token')
    fetch(process.env.REACT_APP_API_BASE_URL + '/yantra/retrieve-all-payed', {
      method: "get",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization' : jwt_token
      }
    })
        .then(response => response.json())
    .then( (response) => {
      console.log("yantra histroy result", response)
      if(response.status && response.status !== 200) {
        localStorage.removeItem('fb_access_token');
        this.googleLogout()
        localStorage.removeItem('google_access_token');
        localStorage.removeItem('y_jwt_token');
        this.setState({pathname : "/", redirect: true});
      }
      if(response){
        this.setState({historyList: response});
      }
    });
    /*window.google.accounts.id.initialize({
      client_id: "189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com",
    });*/
  }
  
  render() {
      return (
        <div className="form-div save">
               {this.renderRedirect()}
            <div className="lbl-group">
              <label className="lbl title">Saved Yantras</label>
            </div>
            <div className="lbl-group">
              <label className="lbl subtitle">Recover your past Yantra reveals</label>
            </div>
              <SaveList historyList={this.state.historyList} onClick={this.setRedirect} />
        </div>
      )
  }
}

export default SaveForm;



// WEBPACK FOOTER //
// ./src/components/Save/SaveForm.js